import React from "react";
import classNames from "classnames";

interface AvatarProps {
    src?: string;
    content?: string;
    size?: "sm" | "lg";
    className?: string;
    rounded?: boolean;
    square?: boolean;
    children?: any;
    [x: string]: any;
}

export const Avatar = ({
    src = null,
    content = null,
    size = null,
    className = null,
    rounded = false,
    square = false,
    children = null,
    ...props
}: AvatarProps) => {
    var cn = classNames("avatar", className, {
        "avatar-rounded": rounded,
        "avatar-square": square,
        "avatar-sm": size === "sm",
        "avatar-lg": size === "lg",
    });

    return (
        <div className={cn} {...props}>
            {!!src && <img src={src} alt="avatar" />}
            {content}
            {children}
        </div>
    );
};
